import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import {
	CategoriesConfig,
	ChartConfig,
	ChartDataConfig,
	ChartToolTipInfoConfig,
	SeriesConfig
} from '../../../analytics-core/interfaces/chart.interface';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, R7_CHARTS_TOOLTIPS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DailyStats, GraphDataModel } from '../daily-stats/daily-stats.component';

HighchartsBorderRadius(Highcharts);
@Component({
	selector: 'app-dynamic-chart',
	styleUrls: ['./dynamic-chart.component.css'],
	templateUrl: './dynamic-chart.component.html'
})
export class DynamicChartComponent implements OnInit, WidgetCore, OnDestroy {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@Input() key: string;
	@Input() sectiontitle: boolean;
	@Input() sectionclass: string;
	@Input() colorsconfig: any;
	@Input() chartconfiguration: any;
	@Input() downloadconfig: any;
	@Input() tooltipconfigname: any;
	@Input() columnsconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() queryorderby: any;
	@Input() downloadcsvorderby: any;
	@Input() downloadiconhtml: any;
	@Input() iscustomendpoint: any;
	public statsColors: string[] = [];
	public colorPalette: ColorPalette;
	colors: any;
	public showLoad = false;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	public toolTipDataConfg;
	public tooltip: any;
	public stepCount;
	public maxPoints = 40;
	public dataLength = 0;
	public leftExtreme = 0;
	public rightExtreme = 0;
	public carouselToken: string;
	public selectedMetric: any;
	public creativeName: string;
	public downloadCSVColumns: any;
	public chartObj: any;
	public downloadConfiguration: DownloadConfig;
	public columns: any[];
	public newTabXLSXRequired: boolean = false;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public widgetClass: string;
	protected dailyStats: DailyStats[] = [];
	protected graphObj: GraphDataModel = {} as GraphDataModel;
	protected defaultCount = 6;
	private chartConfig: ChartConfig;
	public isR8: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.queryorderby = this.queryorderby ? JSON.parse(decodeURI(this.queryorderby)) : [];
		this.downloadcsvorderby = this.downloadcsvorderby ? JSON.parse(decodeURI(this.downloadcsvorderby)) : [];
		this.widgetClass =
			this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() == 'entravision-r103'
				? 'r103_chart_' + this.analyticsDataModel.getCurrentPath()
				: this.analyticsDataModel.config.version.toLowerCase() == 'r1' && this.analyticsDataModel.getCurrentPath() ==  "dooh" ? "r1_chart_" + this.analyticsDataModel.getCurrentPath() : "";
		// filter chartconfiguration series
		if (this.chartConfig && this.chartConfig.seriesConfig) {
			this.chartConfig.seriesConfig = _.filter(this.chartConfig.seriesConfig, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.columns = this.columnsconfig ? JSON.parse(decodeURI(this.columnsconfig)) : [];
		if (
			this.downloadConfiguration &&
			this.downloadConfiguration.permission &&
			this.downloadConfiguration?.permission['flags']
		) {
			this.newTabXLSXRequired = !this.downloadConfiguration.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
		this.requestTooltipDataConfig();
		this.requestData();
	}

	// tslint:disable-next-line:use-life-cycle-interface
	ngAfterViewChecked(): void {
		// Called after every check of the component's view. Applies to components only.
		// Add 'implements AfterViewChecked' to the class.
		// need to re work on this logic
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r7') {
			jQuery('.custom-primary').addClass('r7_primary_bg_color');
		}
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	processColors(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.statsColors = this.colors.split(',');
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key)
				.subscribe((response: any) => {
					if (response.success) {
						this.hasData = true;
						this.processResponseData(response.data);
					} else {
						this.hasData = false;
					}
					this.showLoad = false;
				});
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, this.columns, this.queryorderby)
				.subscribe((response: any) => {
					if (response.success) {
						this.hasData = true;
						this.processResponseData(response.data);
					} else {
						this.hasData = false;
					}
					this.showLoad = false;
				});
		}
	}

	requestTooltipDataConfig(): void {
		if (this.chartConfig.graphConfig.customTooltip === 'r7') {
			this.toolTipDataConfg = {
				...R7_CHARTS_TOOLTIPS,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					const yValue = this.series.name.includes('Rate') ? numeral(this.y).format('0,0.00') + '%' : this.y;
					return `<div style="text-align: center;font-weight: normal;color: #213038;font-size: 12px;">
						${this.series.name.toLocaleString()}
						</div><div style="text-align: center;font-weight: 600;color: #213038;font-size: 12px;">
						${yValue.toLocaleString()}
						</div><div style="text-align: center;font-weight: normal;color: #213038;font-size: 12px;">
						${this.x.toLocaleString()}
						</div>`;
				}
			};
		} else if (this.isR8) {
			this.toolTipDataConfg = {
				borderRadius: 10,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					if (this.point.toolTipData) {
						return `${this.x}<br/>${this.point.toolTipData}`;
					}
					return `${this.x}<br/>${this.point.y}`;
				},
				shared: false
			};
		} else {
			this.toolTipDataConfg = {
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					if (this.point.toolTipData) {
						return `${this.x}<br/>${this.point.toolTipData}`;
					}
					return `${this.x}<br/>${this.point.y}`;
				},
				shared: false
			};
		}
	}

	processResponseData(responseData: any): void {
		this.dailyStats = [];
		this.mapResponseDataToObj(responseData);
		this.processColors();
		this.chartObj = this.generateGraphData(responseData);
		this.dataLength = this.chartObj.categories.categories.length - 1;
		if (this.chartConfig.graphConfig.customTooltip) {
			this.tooltip = {
				...R7_CHARTS_TOOLTIPS,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					return `<div class="legendClass">
					<div class="width100">${this.series.name}</div>
					<div class="width100 yAxisTooltip">${this.point.y.toLocaleString()}</div>
					<div class="width100 dateToolTip">${moment(this.x).format('MM/DD/YY')}</div>
					</div>`;
				}
			};
		} else {
			this.tooltip = {
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					if (this.point.toolTipData) {
						return `${this.x}<br/>${this.point.toolTipData}`;
					}
					return `${this.x}<br/>${this.point.y}`;
				},
				shared: false
			};
		}
		this.generateChartObj();
	}

	mapResponseDataToObj(responseData: any): void {
		for (const responseObj of responseData) {
			const dailyStatsObj: DailyStats = {} as DailyStats;
			dailyStatsObj.date = moment(responseObj.date).format('MM/DD/YYYY');
			dailyStatsObj.keywordImpressions = responseObj.kwd_imps != null ? parseInt(responseObj.kwd_imps, 10) : null;
			dailyStatsObj.totalImpressions =
				responseObj.total_impressions != null ? parseInt(responseObj.total_impressions, 10) : 0;
			dailyStatsObj.ctr = responseObj.click_through_rate != null ? parseFloat(responseObj.click_through_rate) : 0;
			dailyStatsObj.totalClicks = responseObj.total_clicks != null ? parseInt(responseObj.total_clicks, 10) : 0;
			dailyStatsObj.rtgImpressions =
				responseObj.rtg_impressions != null ? parseInt(responseObj.rtg_impressions, 10) : 0;
			dailyStatsObj.geofencingImpressions =
				responseObj.geofencing_impressions != null ? parseInt(responseObj.geofencing_impressions, 10) : 0;
			dailyStatsObj.georecencyImpressions =
				responseObj.georecency_impressions != null ? parseInt(responseObj.georecency_impressions, 10) : 0;
			dailyStatsObj.vtr = responseObj.view_through_rate != null ? parseFloat(responseObj.view_through_rate) : 0;
			dailyStatsObj.viewThroughs = responseObj.view_throughs != null ? parseInt(responseObj.view_throughs, 10) : 0;
			dailyStatsObj.hovers = responseObj.hovers != null ? parseInt(responseObj.hovers, 10) : 0;
			dailyStatsObj.videoPlays = responseObj.video_plays != null ? parseInt(responseObj.video_plays, 10) : 0;
			dailyStatsObj.adInteractionRate =
				responseObj.ad_interaction_rate != null ? parseFloat(responseObj.ad_interaction_rate) : 0;
			dailyStatsObj.adInteractions =
				responseObj.ad_interactions != null ? parseInt(responseObj.ad_interactions, 10) : 0;
			dailyStatsObj.completions = responseObj.completions != null ? parseInt(responseObj.completions, 10) : 0;
			dailyStatsObj.completionRate =
				responseObj.completions_rate != null ? parseFloat(responseObj.completions_rate) : 0;
			this.dailyStats.push(dailyStatsObj);
		}
	}

	generateChartObj(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		_.each(this.chartObj.graphObj.yAxis, (ele: any) => {
			if (ele.labels) {
				ele.labels['formatter'] = function (): string {
					if (this.value >= 1000) {
						return `<span class='xlabel'>${this.value / 1000}k<span>`;
					} else {
						if (this.value % 1 !== 0) {
							return `<span class='xlabel'>${parseFloat(this.value).toFixed(2)}<span>`;
						}
						return `<span class='xlabel'>${this.value}<span>`;
					}
				};
			}
		});
		const chart_margin =
			this.chartObj.graphObj && this.chartObj.graphObj.legendConfig && this.chartObj.graphObj.legendConfig.customMargin
				? this.chartObj.graphObj.legendConfig.customMargin
				: [40, 80, 70, 80];
		const format = this.chartConfig.graphConfig.xAxisConfig.labelFormat
			? this.chartConfig.graphConfig.xAxisConfig.labelFormat
			: 'D-MMM';
		const tickLength =
			this.chartConfig.graphConfig.xAxisConfig.tickLength !== 'undefined' &&
			this.chartConfig.graphConfig.xAxisConfig.tickLength !== null &&
			this.chartConfig.graphConfig.xAxisConfig.tickLength >= 0
				? this.chartConfig.graphConfig.xAxisConfig.tickLength
				: 10;
		Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					alignTicks: this.chartObj.graphObj.alignTicks !== undefined ? this.chartObj.graphObj.alignTicks : true,
					ignoreHiddenSeries:
						this.chartObj.graphObj.ignoreHiddenSeries === false ? this.chartObj.graphObj.ignoreHiddenSeries : true,
					margin: chart_margin
				},
				credits: {
					enabled: false
				},
				legend: this.chartObj.graphObj.legendConfig,
				plotOptions: {
					column: {
						stacking: this.chartObj.graphObj.stacking,
						borderRadius: this.chartConfig?.graphConfig?.legendConfig?.borderRadius
							? this.chartConfig.graphConfig.legendConfig.borderRadius
							: 0
					},
					series: {
						borderWidth: 0,
						states: {
							inactive: {
								opacity: 1
							}
						}
					}
				},
				series: this.chartObj.seriesObj,
				subtitle: {
					text: this.chartObj.graphObj.graphSubTitle
				},
				title: {
					text: this.chartObj.graphObj.graphTitle
				},
				tooltip: this.toolTipDataConfg,
				xAxis: {
					categories: this.chartObj.categories.categories,
					labels: {
						// tslint:disable-next-line: object-literal-shorthand
						formatter: function (): string {
							return moment(this.value).format(format);
						},
						step: this.chartObj.graphObj.stepCount,
						style: this.chartObj.graphObj.xAxisLabelStyle ? this.chartObj.graphObj.xAxisLabelStyle : {},
						y: this.chartObj.graphObj.xaxisLabely || undefined
					},
					tickColor: this.chartConfig.graphConfig.tickColor || '#ccd6eb',
					tickWidth: this.chartConfig.graphConfig.tickWidth || 1,
					tickLength: tickLength,
					tickmarkPlacement: this.chartObj.graphObj.tickmarkPlacement || 'between'
				},
				yAxis: this.chartObj.graphObj.yAxis
			},
			(chart: any) => {
				// on complete
				function noop(): void {}

				if (this.dataLength > this.maxPoints && this.chartConfig.graphConfig.enableGraphNavigation) {
					this.leftExtreme = this.dataLength - this.maxPoints > 0 ? this.dataLength - this.maxPoints : 0;
					this.rightExtreme = this.dataLength;
					chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
					chart.renderer
						.image('../../../../../../assets/creative-assets/arrow-left.png', 0, 0, 6, 9)
						.addClass('left_' + this.key)
						.addClass('cursorPointer')
						.attr('x', '0%')
						.attr('y', '53%')
						.add();
					chart.renderer
						.image('../../../../../../assets/creative-assets/arrow-right.svg', 0, 0, 6, 9)
						.addClass('right_' + this.key)
						.addClass('cursorPointer')
						.attr('x', '99%')
						.attr('y', '53%')
						.add();
					jQuery('.left_' + this.key).click(() => {
						if (this.leftExtreme > 0) {
							this.rightExtreme = this.leftExtreme - 1;
							this.leftExtreme = this.leftExtreme - this.maxPoints > 0 ? this.leftExtreme - this.maxPoints : 0;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
						}
					});
					jQuery('.right_' + this.key).click(() => {
						if (this.rightExtreme < this.dataLength) {
							this.leftExtreme = this.rightExtreme + 1;
							this.rightExtreme =
								this.leftExtreme + this.maxPoints > this.dataLength
									? this.dataLength
									: this.leftExtreme + this.maxPoints;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
						}
					});
				}
			}
		);
		this.dynamicWidth();
	}

	calculateStepCount(dataLength: any): number {
		if (dataLength <= this.defaultCount) {
			return 1;
		}
		return this.chartConfig.graphConfig.enableGraphNavigation ? 2 : Math.ceil(dataLength / (this.defaultCount * 2));
	}

	dynamicWidth(): void {
		// tslint:disable
		(function (H) {
			const each = H.each;
			H.wrap(H['seriesTypes'].column.prototype, 'drawPoints', function (proceed) {
				const series = this;
				if (series.data.length > 0) {
					const width = series.barW > series.options.maxPointWidth ? series.options.maxPointWidth : series.barW;
					each(this.data, function (point) {
						point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
						point.shapeArgs.width = width;
					});
				}
				proceed.call(this);
			});
		})(Highcharts);
		// tslint:enable
	}

	buildSeriesWithToolTipInfo(infoObj: any, totalDataLength: number): any[] {
		const seriesData = [];
		for (let i = 0; i < totalDataLength; i++) {
			const tempObj: any = {};
			let toolTipHTML = '';

			for (const info of infoObj) {
				if (info.isSeriesData) {
					tempObj.y = info.data[i];
				}
				const value = info.data[i];
				toolTipHTML +=
					// tslint:disable-next-line: prefer-template
					'<div>' +
					info.name +
					' : ' +
					(this.isFloat(value) ? numeral(value).format('0,0.00') + '%' : numeral(value).format('0,0')) +
					'</div><br/>';
			}
			tempObj.toolTipData = toolTipHTML;
			seriesData.push(tempObj);
		}
		return seriesData;
	}

	downloadDataInCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns,
			this.downloadcsvorderby,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}

	private generateGraphData(responseData: any): void {
		const graphData: any = {};
		const processedData = this.generateResponseDataFromConfig(responseData);
		const seriesData = this.buildSeriesDataFromConfig(processedData);
		const categoriesData = this.buildCategoriesDataFromConfig(processedData);
		graphData.graphObj = this.chartConfig.graphConfig;
		graphData.graphObj.stepCount = this.calculateStepCount(categoriesData.categories.length);
		graphData.seriesObj = seriesData;
		graphData.categories = categoriesData;
		return graphData;
	}

	private generateResponseDataFromConfig(responseData: any): any[] {
		const processedData = [];
		for (const responseObj of responseData) {
			processedData.push(this.getDerivedResponseObj(responseObj));
		}
		return processedData;
	}

	private getDerivedResponseObj(responseObj: any): any {
		const fields: ChartDataConfig[] = this.chartConfig.chartDataConfig;
		const fieldObj: any = {};

		for (const field of fields) {
			if (field.fieldType === 'number') {
				fieldObj[field.fieldName] = !UtilityService.isUndefinedOrNull(responseObj[field.fieldKey])
					? parseFloat(responseObj[field.fieldKey])
					: 0;
			} else if (field.fieldType === 'string') {
				fieldObj[field.fieldName] = !UtilityService.isUndefinedOrNull(responseObj[field.fieldKey])
					? responseObj[field.fieldKey]
					: '';
			} else if (field.fieldType === 'date') {
				fieldObj[field.fieldName] = !UtilityService.isUndefinedOrNull(responseObj[field.fieldKey])
					? moment(responseObj[field.fieldKey]).format(field.fieldFormat)
					: '';
			}
		}
		return fieldObj;
	}

	private buildCategoriesDataFromConfig(responseData: any): any {
		const categoriesObj: CategoriesConfig = this.chartConfig.categoriesConfig;
		const categories: any = {};
		categories.categories = _.pluck(responseData, categoriesObj.categoriesKey);
		return categories;
	}

	private buildSeriesDataFromConfig(responseData: any): SeriesConfig[] {
		const seriesConfig: SeriesConfig[] = this.chartConfig.seriesConfig;

		const seriesData: any[] = [];
		for (const seriesObj of seriesConfig) {
			const series: any = {};
			series.type = seriesObj.type;
			series.name = seriesObj.seriesName;
			series.fillOpacity = seriesObj.fillOpacity;
			if (seriesObj.yAxis) {
				series.yAxis = seriesObj.yAxis;
				series.opposite = seriesObj.opposite;
			}
			series.color = this.getColorFromColorConfiguration(seriesObj.colorConfig);
			series.legendIndex = seriesObj.legendIndex;
			if (
				this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r103' ||
				this.analyticsDataModel.config.directoryName.toLowerCase() == 'entravision-r103'
			) {
				series.maxPointWidth = seriesObj.maxPointWidth;
				series.pointPadding = seriesObj.pointPadding;
				series.groupPadding = seriesObj.groupPadding;
				series.borderWidth = seriesObj.borderWidth;
				series.lineWidth = seriesObj.lineWidth;
			}
			if( this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r1') {
				series.maxPointWidth = seriesObj.maxPointWidth;
			}
			series.marker = seriesObj.marker;
			const seriesInfo: any = this.generateToolTipObjFromConfig(responseData, seriesObj.tooltipInfo);
			series.data = this.buildSeriesWithToolTipInfo(seriesInfo, seriesInfo[0].data.length);
			series.borderRadiusTopLeft = seriesObj.borderRadiusTopLeft ? seriesObj.borderRadiusTopLeft : '0%';
			series.borderRadiusTopRight = seriesObj.borderRadiusTopRight ? seriesObj.borderRadiusTopRight : '0%';
			series.borderRadiusBottomLeft = seriesObj.borderRadiusBottomLeft ? seriesObj.borderRadiusBottomLeft : '0%';
			series.borderRadiusBottomRight = seriesObj.borderRadiusBottomRight ? seriesObj.borderRadiusBottomRight : '0%';
			if (seriesObj.states) {
				series.states = seriesObj.states;
			}
			series.max = seriesObj.max ? seriesObj.max : null;
			seriesData.push(series);
		}
		return seriesData;
	}

	private generateToolTipObjFromConfig(responseData: any, tooltipInfoArray: ChartToolTipInfoConfig[]): any[] {
		const tooltipArray: any[] = [];
		for (const tooltipInfoObj of tooltipInfoArray) {
			const tooltipObj: any = {};
			let data = [];
			if (
				tooltipInfoObj.customMetric &&
				this.analyticsDataModel.checkComponentForPermission(tooltipInfoObj.customMetric)
			) {
				data = _.pluck(responseData, tooltipInfoObj.customMetric.key);
			} else {
				data = _.pluck(responseData, tooltipInfoObj.key);
			}

			tooltipObj.name = tooltipInfoObj.name;
			tooltipObj.data = data;
			tooltipObj.isSeriesData = tooltipInfoObj.showInSeries;
			tooltipArray.push(tooltipObj);
		}
		return tooltipArray;
	}

	private getColorFromColorConfiguration(colorConfig: ColorConfig): string {
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, colorConfig.opacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, colorConfig.opacity);
		}
		return rgb;
	}

	private isFloat(n: any): boolean {
		return Number(n) === n && n % 1 !== 0;
	}
}
